import React from 'react';
import {
  Question,
  QuestionPayload,
} from '../../../../datasources/questions/QuestionsDataSource';
import { Basket } from '../../../../types/basket/Basket';
import { DialogQuestion } from './dialogQuestion';

type EditQuestionDialogProps = {
  open: boolean;
  question: Question;
  questions: Question[];
  baskets: Basket[];
  basketsLoading: boolean;
  basketsError?: string;
  onClose: () => void;
  loading?: boolean;
  error?: string;
  onConfirm: (
    questionId: number,
    payload: QuestionPayload
  ) => void | Promise<void>;
};

export const EditQuestionDialog: React.FC<EditQuestionDialogProps> = ({
  open,
  question,
  questions,
  baskets,
  basketsLoading,
  basketsError,
  onClose,
  loading = false,
  error,
  onConfirm,
}) => (
  <DialogQuestion
    open={open}
    mode="edit"
    onClose={onClose}
    loading={loading}
    error={error}
    questions={questions}
    baskets={baskets}
    basketsLoading={basketsLoading}
    basketsError={basketsError}
    initialQuestion={question}
    onConfirm={(payload) => onConfirm(question.id, payload)}
  />
);
